import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useVideoCache } from './cache'
import { toResponseError, type VideoUpdateInput, type VideoUpdateSuccess } from '@terros/common'

export function useUpdateVideo(): UpdateHookResponse<VideoUpdateInput, VideoUpdateSuccess> {
  const mutation = useTantalimMutation<VideoUpdateInput, VideoUpdateSuccess>({
    url: '/video/update',
  })
  const cache = useVideoCache()

  async function update(input: VideoUpdateInput): Promise<VideoUpdateSuccess> {
    try {
      const updated = await mutation.mutateAsync(input)
      cache.replaceItem(updated.video)
      return updated
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
